import { createAction } from 'redux-actions'
import { fetchRefundDetail, fetchGetCouponConfigure, fetchGetBusinessTypesByPage } from "@/api/service/tool";
import { SOURCE } from "../../../containers/tool/compensate/config";
export const initStateData = {
    status: 0,
    comment: {
        orderId: "",
        ticketid: "",
        phone: "",
        area: null,
        source: SOURCE.COMPEN,
        businessType: 1,
    },
}

export const resetState = createAction('RESET_ALLPROMOTION_STATE', () => (initStateData))
export const resetFetchState = createAction('RESET_ALLPROMOTION_FETCH_STATE')

// 清空乘客退款
export const clearTravelRefundDetail = createAction('CLEAR_PASSENGER_TRAVELREFUND')

// 乘客退款 
export const getPassengerTravelRefundDetailSuccess = createAction('GET_PAYINFO_SUCCESS')
export const getPassengerTravelRefundDetail = function (data) {
    return (dispatch) => {
        return fetchRefundDetail(data)
            .then((res) => res.data)
            .then((json) => {
                dispatch(getPassengerTravelRefundDetailSuccess(json.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 获取可用优惠券
export const getCouponConfigureSuccess = createAction('GET_COUPONCONFIGURE_SUCCESS')
export const getCouponConfigure = function (data) {
    return (dispatch) => {
        return fetchGetCouponConfigure(data)
            .then((res) => res.data)
            .then((json) => {
                dispatch(getCouponConfigureSuccess(json.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

// 获取业务类型
export const getBusinessTypesByPageSuccess = createAction('GET_BUSINESSTYPESBYPAYE_SUCCESS')
export const getBusinessTypesByPage = function (data) {
    return (dispatch) => {
        return fetchGetBusinessTypesByPage(data)
            .then((res) => res.data)
            .then((json) => {
                dispatch(getBusinessTypesByPageSuccess(json.data))
            })
            .catch((err) => {
                console.info(err);
            });
    };
};

